import { http } from '@/providers/apis/http';
import { independentStudySerializer } from '@/providers/serializers/independent-study/independent-study';

export class IndependentStudyAPI {
    public static INSTANCE = new IndependentStudyAPI();
    public programId: any;

    static get instance() {
        return this.INSTANCE;
    }

    private namespaceAdmin: string = 'api/admin/v1/';

    private namespaceProgram: string = 'api/internal/v1/';

    public fetchNavigatorPrograms(params: any) {
        const endpoint = `${this.namespaceAdmin}/navigator/program?offset=${params.offset}&limit=${params.limit}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return independentStudySerializer.selializePrograms(response.data);
        });
    }
    public createNavigatorProgram(params: any) {
        const endpoint = `${this.namespaceAdmin}navigator/program`;
        const headers = http.getTokenHeaders();
        const serializedProgram = independentStudySerializer.normalizeCreateProgram(params);
        return http.post(endpoint, headers, serializedProgram).then((response) => {
            this.programId = response.headers.location;
            return response;
        });
    }
    public indexProgram() {
        const endpoint = `${this.namespaceProgram}navigator/protected/search/index/programs`;
        const headers = http.getTokenHeaders();
        const params = {
            programIds: [
                this.programId,
            ],
        };
        return http.post(endpoint, headers, params).then((response) => {
            return response;
        });
    }

    public updateNavigatorProgram(params: any, programId: any) {
        const endpoint = `${this.namespaceAdmin}navigator/program/${programId}`;
        const headers = http.getTokenHeaders();
        const serializedProgram = independentStudySerializer.normalizeCreateProgram(params);
        return http.put(endpoint, headers, serializedProgram).then((response) => {
            return response;
        });
    }

    public filterNavigatorPrograms(params: any, filterKeyList: any) {
        const baseUrl = `${this.namespaceAdmin}navigator/program?offset=${params.offset}&limit=${params.limit}`;
        const queryParams = filterKeyList.map((filter: any) =>
            `${filter.key}=${encodeURIComponent(filter.value)}`).join('&');
        const endpoint = `${baseUrl}&${queryParams}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return independentStudySerializer.selializePrograms(response.data);
        });
    }
}
export const independentStudyApi = IndependentStudyAPI.instance;
